import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "Choose different settings from the dropdown menus regarding the type of source, its power and directivity, and the environment it is placed into. For the sound source, listen to the resulting sound at different positions around the source. For the heat source, observe the resulting temperature at different positions.",
  theory: theory,
  layout: {
    type: "custom050600",
    options: {
      sound: {
        "high-high-closedRoom": [
          `${config.ASSETS_URL}/05/06/principle/high-high-closedRoom-1.wav`,
          `${config.ASSETS_URL}/05/06/principle/high-high-closedRoom-2.wav`,
          `${config.ASSETS_URL}/05/06/principle/high-high-closedRoom-3.wav`,
          `${config.ASSETS_URL}/05/06/principle/high-high-closedRoom-4.wav`,
          `${config.ASSETS_URL}/05/06/principle/high-high-closedRoom-5.wav`,
          `${config.ASSETS_URL}/05/06/principle/high-high-closedRoom-6.wav`,
        ],
        "high-high-openSpace": [
          `${config.ASSETS_URL}/05/06/principle/high-high-freeField-1.wav`,
          `${config.ASSETS_URL}/05/06/principle/high-high-freeField-2.wav`,
          `${config.ASSETS_URL}/05/06/principle/high-high-freeField-3.wav`,
          `${config.ASSETS_URL}/05/06/principle/high-high-freeField-4.wav`,
          `${config.ASSETS_URL}/05/06/principle/high-high-freeField-5.wav`,
          `${config.ASSETS_URL}/05/06/principle/high-high-freeField-6.wav`,
        ],
        "high-omni-closedRoom": [
          `${config.ASSETS_URL}/05/06/principle/high-omni-closedRoom-1.wav`,
          `${config.ASSETS_URL}/05/06/principle/high-omni-closedRoom-2.wav`,
          `${config.ASSETS_URL}/05/06/principle/high-omni-closedRoom-3.wav`,
          `${config.ASSETS_URL}/05/06/principle/high-omni-closedRoom-4.wav`,
          `${config.ASSETS_URL}/05/06/principle/high-omni-closedRoom-5.wav`,
          `${config.ASSETS_URL}/05/06/principle/high-omni-closedRoom-6.wav`,
        ],
        "high-omni-openSpace": [
          `${config.ASSETS_URL}/05/06/principle/high-omni-freeField-1.wav`,
          `${config.ASSETS_URL}/05/06/principle/high-omni-freeField-2.wav`,
          `${config.ASSETS_URL}/05/06/principle/high-omni-freeField-3.wav`,
          `${config.ASSETS_URL}/05/06/principle/high-omni-freeField-4.wav`,
          `${config.ASSETS_URL}/05/06/principle/high-omni-freeField-5.wav`,
          `${config.ASSETS_URL}/05/06/principle/high-omni-freeField-6.wav`,
        ],
        "low-high-closedRoom": [
          `${config.ASSETS_URL}/05/06/principle/low-high-closedRoom-1.wav`,
          `${config.ASSETS_URL}/05/06/principle/low-high-closedRoom-2.wav`,
          `${config.ASSETS_URL}/05/06/principle/low-high-closedRoom-3.wav`,
          `${config.ASSETS_URL}/05/06/principle/low-high-closedRoom-4.wav`,
          `${config.ASSETS_URL}/05/06/principle/low-high-closedRoom-5.wav`,
          `${config.ASSETS_URL}/05/06/principle/low-high-closedRoom-6.wav`,
        ],
        "low-high-openSpace": [
          `${config.ASSETS_URL}/05/06/principle/low-high-freeField-1.wav`,
          `${config.ASSETS_URL}/05/06/principle/low-high-freeField-2.wav`,
          `${config.ASSETS_URL}/05/06/principle/low-high-freeField-3.wav`,
          `${config.ASSETS_URL}/05/06/principle/low-high-freeField-4.wav`,
          `${config.ASSETS_URL}/05/06/principle/low-high-freeField-5.wav`,
          `${config.ASSETS_URL}/05/06/principle/low-high-freeField-6.wav`,
        ],
        "low-omni-closedRoom": [
          `${config.ASSETS_URL}/05/06/principle/low-omni-closedRoom-1.wav`,
          `${config.ASSETS_URL}/05/06/principle/low-omni-closedRoom-2.wav`,
          `${config.ASSETS_URL}/05/06/principle/low-omni-closedRoom-3.wav`,
          `${config.ASSETS_URL}/05/06/principle/low-omni-closedRoom-4.wav`,
          `${config.ASSETS_URL}/05/06/principle/low-omni-closedRoom-5.wav`,
          `${config.ASSETS_URL}/05/06/principle/low-omni-closedRoom-6.wav`,
        ],
        "low-omni-openSpace": [
          `${config.ASSETS_URL}/05/06/principle/low-omni-freeField-1.wav`,
          `${config.ASSETS_URL}/05/06/principle/low-omni-freeField-2.wav`,
          `${config.ASSETS_URL}/05/06/principle/low-omni-freeField-3.wav`,
          `${config.ASSETS_URL}/05/06/principle/low-omni-freeField-4.wav`,
          `${config.ASSETS_URL}/05/06/principle/low-omni-freeField-5.wav`,
          `${config.ASSETS_URL}/05/06/principle/low-omni-freeField-6.wav`,
        ],
      },
    },
  },
};

export default principle;
